import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { UserMiniEntity } from '../../domain/entities/UserMiniEntity'

export class UserMiniModel extends UserMiniEntity {
  constructor(dataDto: UserMiniEntity) {
    super()
    mapEntityProperties<UserMiniEntity>(this, dataDto)
  }
}
